// themeParse mirrors the Go ParseTheme shape from
// backend/internal/publisher/theme_apply.go. An empty / "{}" / malformed
// payload falls back to the Editorial Warm preset; valid JSON with
// partial fields is merged on top of the preset so the rest of the UI
// never has to handle missing palette entries.
import type { Theme } from '@/types/theme';
import { EDITORIAL_WARM } from '@/lib/themePresets';

export function parseTheme(raw: string | null | undefined): Theme {
  if (!raw) return cloneTheme(EDITORIAL_WARM);
  const trimmed = raw.trim();
  if (trimmed === '' || trimmed === '{}') return cloneTheme(EDITORIAL_WARM);
  let parsed: Partial<Theme>;
  try {
    parsed = JSON.parse(trimmed) as Partial<Theme>;
  } catch {
    return cloneTheme(EDITORIAL_WARM);
  }
  return {
    palette: { ...EDITORIAL_WARM.palette, ...(parsed.palette ?? {}) },
    typography: { ...EDITORIAL_WARM.typography, ...(parsed.typography ?? {}) },
  };
}

function cloneTheme(t: Theme): Theme {
  return {
    palette: { ...t.palette },
    typography: { ...t.typography },
  };
}
